import React, { FunctionComponent } from "react";
import DynamicAnalysisGrid from "../../../common/dynamicanalysis/DynamicAnalysisGrid";
import { JoeBehaviorGraphItem } from "../../../../@types";
import { behaviorGraph } from "./schema";

interface BehaviorGraphProps {
  data?: JoeBehaviorGraphItem[];
}

const BehaviorGraph: FunctionComponent<BehaviorGraphProps> = ({ data }) => (
  <DynamicAnalysisGrid data={data} schema={behaviorGraph} />
);

export default BehaviorGraph;
